import { render, staticRenderFns } from "./FooterOpenApp.vue?vue&type=template&id=4fa5de62&scoped=true"
import script from "./FooterOpenApp.vue?vue&type=script&lang=js"
export * from "./FooterOpenApp.vue?vue&type=script&lang=js"
import style0 from "./FooterOpenApp.vue?vue&type=style&index=0&id=4fa5de62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa5de62",
  null
  
)

export default component.exports